import { styled, CardMedia, CardMediaProps, CircularProgress } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';
import { fadeIn } from 'assets/styles/animations';

const spinnerBgColor = theme.palette.neutral.light;
const spinnerColor = palette.neutral[400];

interface StyledCardMediaProps extends CardMediaProps {
  component: string;
}

export const StyledCardMedia = styled(CardMedia)<StyledCardMediaProps>`
  animation: ${fadeIn} 0.5s ease-in forwards;
  opacity: 0;
`;

export const SpinnerWrapper = styled('div')`
  align-items: center;
  background: ${spinnerBgColor};
  display: flex;
  justify-content: center;
  min-height: 130px;

  ${theme.breakpoints.up('md')} {
    min-height: 176px;
  }
`;

export const Spinner = styled(CircularProgress)`
  svg {
    transform: scale(75%);
    color: ${spinnerColor};
  }
`;
